import { render, staticRenderFns } from "./purchaseMember.vue?vue&type=template&id=5dc7cfee"
import script from "./purchaseMember.vue?vue&type=script&lang=js"
export * from "./purchaseMember.vue?vue&type=script&lang=js"
import style0 from "./purchaseMember.vue?vue&type=style&index=0&id=5dc7cfee&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports